import { useRouter } from 'next/router';
import { useState } from 'react';
import ProductSmallTile from '../components/product-tile/product-small-tile';
import { server } from './../config';
import logo from './../public/CherryLogoWhite.png';
import styles from './index.module.css';
import hair from './../assets/hair.png';
import skin from './../assets/skin.png';
import beard from './../assets/beard.png';
import moroccanoil from './../assets/maroccanoil.png';
import frontImage from './../assets/front-img.jpg';
import FrontProducts from '../components/front-products/front-products';
import Head from 'next/head';
export default function Home() {

 

  const router = useRouter();



  return (
    <>
    <Head>
      <title>Cherryblossom.no | Sammenlign priser på skjønnhetsprodukter</title>
      <meta name="description" content="Sammenlign priser på kosmetikk, hårpleie, hudpleie og skjeggpleie fra norske nettbutikker. Finn produktet du ønsker til best pris." />
      <link rel="canonical" href="https://cherryblossom.no/" />
      <meta property="og:url" content="https://cherryblossom.no/" />
    </Head>
    <div className={styles.container} style={{ zIndex: 1001, initialLetter: 1 }}>
      <main style={{marginTop: '16px'}}>
        <div className={styles.hero}>
          <article className={styles.indexArticle}>
            <img src={logo.src} style={{height: '42px', float: 'left', margin: '8px'}} alt="Logo" className="showInMobile"/>
            <h1 className={styles.title} style={{marginTop: 0}}>Cherryblossom.no - <small>Hvordan fungerer det?</small></h1>
          <p>
            - Å navigere i skjønnhetsverdenen kan være utfordrende med alle de ulike produktene og trendene. 
            Vi gjør det enklere for deg ved å samle et nøye utvalgt sortiment av skjønnhets- og kosmetikkprodukter
             fra flere leverandører på ett sted. Fra hudpleie til makeup - vi gir deg tilgang til det du trenger, 
             uten at du blir overveldet.
          </p>
          <p>
            Hvis flere butikker tilbyr samme produkt, viser vi deg hvor du kan få det til best pris. 
            Vi ønsker å gjøre skjønnhet enklere og mer tilgjengelig, så du kan fokusere på å føle deg bra.
          </p>
          </article>
          <div className={styles.frontImage} id="indexImg" style={{backgroundImage: `url(${frontImage.src})`}}></div>
        </div>
        <section>
          <h2>Populære kategorier</h2>
          <article className={styles.categoryContainer}>
            <div className={styles.category} onClick={() => router.push('produkter/haarpleie')}><div>Hårpleie</div><div id="hair"></div></div>
            <div className={styles.category} onClick={() => router.push('produkter/hudpleie')}><div>Hudpleie</div><div id="skin"></div></div>
            <div className={styles.category} onClick={() => router.push('produkter/moroccanoil')}><div>Moroccanoil</div><div id="moroccanoil"></div></div>
            <div className={`${styles.category}`} onClick={() => router.push('produkter/skjeggpleie')}><div>Skjeggpleie</div><div id="beard"></div></div>
          </article>
        </section>
        <br/>
        <FrontProducts />
      </main>
      <br />
      <div className="showInMobile" style={{ marginTop: '32px' }}>
        
      </div>     
        <style jsx>{`
        #hair {
          background-image: url('${hair.src}');
          background-position: top center;
          background-size: contain;
        }
        #skin {
          background-image: url('${skin.src}');
          background-position: top center;
          background-size: contain;
        }
        #moroccanoil {
          background-image: url('${moroccanoil.src}');
          background-position: top center;
          background-size: contain;
        }
        #beard {
          background-image: url('${beard.src}');
          background-position: top center;
          background-size: contain;
        }                                     
      `}</style>        
    </div>
    </>
    
  );
}
